export default {
  computed: {
    message () {
      return this.$store.state.global.message
    }
  },
  watch: {
    message: function (message) {
      const toast = this.$createToast(message, false)
      toast.show()
    }
  }
}
